import { DataService } from '../../base-data-services/data.service';
import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';
import { API_URL,FORM_STEP_OPTIONS } from 'common/constants/sm-constants';
import { multipleAPIObject } from 'common/models/utility-models/utility-interface';
import { applicantDashboardModel } from 'common/models/page-models/applicants/applicant-dashboard/applicant-dashboard-data.model';

@Injectable({
  providedIn: 'root',
})
export class applicantDashboardService extends DataService<applicantDashboardModel> {
  constructor(http: SmApiService, protected ss: SystemService
  ) {
    super(ss, API_URL.getapplicantDashboard, http);
  }

  createInstance(): applicantDashboardModel {
    return new applicantDashboardModel();
  }

  override apiCallFromMultipleAPIforGrid(urlList: multipleAPIObject[]) {
    const allPromises = urlList.map((urlItem) => {

      return this.apiService.postData(urlItem.url, urlItem.payload);
    });
    return new Promise((resolve, reject) => {
      Promise.all(allPromises)
        .then((data) => {
          const modifiedData = data.map((result) =>result);
          const mapChartData=this.modifyApplicantDashboardModel(modifiedData);
          resolve(mapChartData);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }




   public modifyApplicantDashboardModel(model: any) {
    // console.log(model,'modifyApplicantDashboardModel')
    const dataModel = this.createInstance();
     dataModel.formstateList=model[1].details || model[1];
    dataModel.genderData = model[0].details.genderData[0];
    dataModel.branchData=  model[0].details.branchData;
    dataModel.branchCatData= model[0].details.branchCatData;
    dataModel.stateData= model[0].details.stateData;
    dataModel.regionalData= model[0].details.regionData;
    dataModel.regionalData.forEach((region) => {
      dataModel.region_progress[region.region] = (region.regionApplicantCount / model[0].details.genderData[0].totalApplicant) * 100;
    })

    dataModel.categoryData = model[0].details.CategoryData[0].StatusApplicantCount
    dataModel.genderDataChart = {
      chart: {
        type: 'pie',
      },
      slicedOffset: 0,
      yAxis: {
        labels: {
          enabled: false,
        },
      },
      xAxis: {
        labels: {
          enabled: false,
        },
      },
      title: undefined,
      legend: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          allowPointSelect: false,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
        },
        series: {
          allowPointSelect: false,
          animation: false,
          states: {
            hover: {
              enabled: false,
            },
            inactive: {
              opacity: 1,
            },
          },
        },
      },
      series: [
        {
          innerSize: '80%',
          data: [
            {
              name: 'Male',
              y: parseInt(model[0].details.genderData[0].maleCount),
              color: '#003F7F',
              showInLegend: false,
            },
            {
              name: 'Female',
              y: parseInt(model[0].details.genderData[0].femaleCount),
              color: '#FF017E',
              showInLegend: false,
            },
            {
              name: 'Other',
              y: parseInt(model[0].details.genderData[0].otherCount),
              color: 'gray',
              showInLegend: false,
            },
          ],
        },
      ],
    };
    console.log(model[0]);
    
    dataModel.chartOptionsCategory={
      series: [
        Math.round(parseInt(model[0].details.CategoryData[0].appliedCount)),
        Math.round(parseInt(model[0].details.CategoryData[0].deligenceCount)),
        Math.round(parseInt(model[0].details.CategoryData[0].documentationCount)),
        Math.round(parseInt(model[0].details.CategoryData[0].assessmentCount)),
        Math.round(parseInt(model[0].details.CategoryData[0].interviewCount)),
        Math.round(parseInt(model[0].details.CategoryData[0].homeVisitCount)),
        Math.round(parseInt(model[0].details.CategoryData[0].ShortlistingCount)),
        Math.round(parseInt(model[0].details.CategoryData[0].rejectedCount))
      ],
      chart: {
        height: 280,
        type: "radialBar"
      },
      plotOptions: {
        radialBar: {
          offsetY: 0,
          startAngle: 0,
          endAngle: 270,
          hollow: {
            margin: 0,
            size: "30%",
            background: "transparent",
            image: undefined
          },
          dataLabels: {
            name: {
              show: false
            },
            value: {
              show: false
            }
          }
        }
      },
      // colors: ['#008000', '#00A36C', '#2AAA8A', '#808000', '#8A9A5B', '#009E60', '#50C878'],
      colors: ['#FC0D1C', '#FD7E23', '#FFD700', '#009E60', '#0C24FB', '#490D81', '#931DD0'],
      labels: ['Applied', 'Due Diligence', 'Documentation', 'Assessment', 'Interview', 'Home Visit', 'Shortlisting','Rejected'],
      legend: {
        show: true,
        floating: true,
        fontSize: "9px",
        position: "left",
        horizontalAlign: "right",
        offsetX: 1,
        offsetY: 0,
        labels: {
          useSeriesColors: true
        },
        formatter: function (seriesName, opts) {
          return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex];
        },
        itemMargin: {
          horizontal: 3
        }
      }
    }
    return dataModel;
  }
}
